import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Branch } from '../branc.model';
import { DisplayModes } from '../../../models/enums';
import { BranchesService } from '../branches.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { AppTranslationService } from '../../../services/app-translation.service';
import { BricksService } from '../../../settings/services/bricks.service';

@Component({
  selector: 'crm-save-branch',
  templateUrl: './save-branch.component.html',
  styleUrls: ['./save-branch.component.css']
})
export class SaveBranchComponent implements OnInit {

  displayMode: DisplayModes = DisplayModes.Success;
  branch: Branch = new Branch();
  //itemFormatId: number;
  bricks: any = [];

  @Output() closeEvent = new EventEmitter<boolean>();
  @Input() branchId: number;
  constructor(private readonly branchesService: BranchesService,
    private readonly route: ActivatedRoute, private readonly brickService: BricksService,
    private readonly router: Router,
    private readonly translateService: AppTranslationService,
    private readonly alertService: AlertService) { }

  ngOnInit() {
    if (this.branchId != undefined)
      this.getBranch(this.branchId);
    this.getBricks();
  }

  getBranch(branchId) {
    this.displayMode = DisplayModes.Loading;
    this.branchesService.getById(branchId).subscribe(responce => {
      this.displayMode = DisplayModes.Success;
      this.branch = responce as Branch;
      if (this.branch && this.branch.brickId && this.bricks)
        this.branch.brick = this.bricks.find(x => x.id == this.branch.brickId)
    },
      err => {
        this.displayMode = DisplayModes.Error;
        console.log('error in get item Branch');
        console.log(err);
      });
  }

  save(form) {
    if (!form.invalid) {

      this.displayMode = DisplayModes.Loading;
      this.branch.brickId = null;
      if (this.branch.brick)
        this.branch.brickId = this.branch.brick.id

      this.alertService.startLoadingMessage("", this.translateService.getTranslation("Saving"));
      this.branchesService.save(this.branch).subscribe(() => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Success;
        this.back();
        this.alertService.showMessage("", this.translateService.getTranslation("clm.savedSuccessfully"), MessageSeverity.Success);
      }, () => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Error;
      });
    }
  }

  back() {
    this.closeEvent.emit(true);
  }

  getBricks() {
    this.brickService.getAllBricks('').subscribe(response => {
      let result = response as any[];
      this.bricks = result;
      if (this.branch && this.branch.brickId && this.bricks)
        this.branch.brick = this.bricks.find(x => x.id == this.branch.brickId)
    }, err => {
      console.log(err);
    });
  }

}
